module.exports = "https://r.zoocdn.com/_next/static/images/house-with-tree-c36fdaf3a8b7e55867f9e7867e254540.svg";